import {createApp} from 'vue';

// YouTube IFrame API types
declare global {
    interface Window {
        YT: any;
        onYouTubeIframeAPIReady: () => void;
    }
}

const app = createApp({
    data() {
        return {
            youtubePlayer: null as any,
            showLogo: true,
        };
    },
    mounted() {
        this.initYouTubePlayer();
    },
    methods: {
        ctaClick: function() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        initYouTubePlayer: function() {
            // Load YouTube IFrame API if not already loaded
            if (!window.YT) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

                window.onYouTubeIframeAPIReady = () => {
                    this.createYouTubePlayer();
                };
            } else {
                this.createYouTubePlayer();
            }
        },
        createYouTubePlayer: function() {
            const playerElement = document.getElementById('youtube-player');
            if (!playerElement) return;

            this.youtubePlayer = new window.YT.Player('youtube-player', {
                height: '315',
                width: '100%',
                videoId: 'x9auaO3ZtZw',
                playerVars: {
                    'modestbranding': 1,
                    'iv_load_policy': 3,
                    'rel': 0,
                    'showinfo': 0,
                    'controls': 1,
                    'fs': 1,
                    'cc_load_policy': 0,
                    'autohide': 0,
                },
                events: {
                    'onReady': this.onPlayerReady,
                    'onStateChange': this.onPlayerStateChange,
                },
            });
        },
        onPlayerStateChange: function(event: any) {
            const stateNames = {
                0: 'Ended',
                1: 'Playing',
                2: 'Paused',
                3: 'Buffering',
                5: 'Cued',
            };

            const stateName = stateNames[event.data as keyof typeof stateNames] || 'Unknown';

            // Control logo visibility based on player state
            if (event.data === 1) { // Playing
                this.showLogo = false;
            } else if (event.data === 2 || event.data === 0) { // Paused or Ended
                this.showLogo = true;
            }

            if (typeof window.sendAnalyticsEvent === 'function') {
                if (event.data === 1) { // Playing
                    window.sendAnalyticsEvent('Video Engagement', `Video ${stateName}`, 'TV Campaign Video - Iframe');
                } else if (event.data === 0) { // Ended
                    window.sendAnalyticsEvent('Video Engagement', `Video ${stateName}`, 'TV Campaign Video - Iframe');
                }
            }
        },
    },
});

app.mount('#home-content');
